<template>
  <div>
    <div class="__box-wrap" v-show="isShow">
      <div class="__box-cover"/>
      <div class="__box-content">
        <i class="icon_close iconfont icon-cha" @click="isShow = false"/>
        <div class="box-list">

          <table>
            <thead>
            <tr class="table-header">
              <th class="num">序号</th>
              <th class="user">邀请用户</th>
              <th class="create-time">注册时间</th>
            </tr>
            </thead>
            <tbody class="table-body">
            <tr v-for="(vo,idx) in inviteList">
              <td>{{ idx + 1 }}</td>
              <td>{{ vo.invitee }}</td>
              <td>{{ vo.create_time }}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "InviteRecordDialog",
  data() {
    return {
      isShow: false
    }
  },
  props: {
    inviteList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>


.__box-wrap {
  @include ModalBox(744, 520);

  .__box-content {
    @include BgImage(744px, 520px, 'act/invite-friends/invite-dialog.png');
    overflow: visible;


    .icon_close {
      @include LayoutFlex(1);
      width: 38px;
      height: 38px;
      background: rgba(255, 255, 255, 0.8);
      border-radius: 50%;
      font-size: 17px;
      color: #20395B;
      @include Position(1, 2, -38px, 43px);
      transition: all 0.3s ease-in;
      @include ElementHover('', #FFFFFF);
    }

    .box-list {
      width: 706px;
      height: 418px;
      overflow-y: scroll;
      margin: 82px 0 0 19px;
      border-radius: 20px;

    }

    table {
      width: 706px;
      background: #FFFFFF;
      border-radius: 20px;
      //margin: 82px 0 0 19px;

      .table-header {
        height: 97px;
        line-height: 97px;
        font-size: 16px;
        font-weight: 400;

        th {
          font-weight: normal;
        }

        color: #9394A9;

        .num {
          width: 170px;
        }

        .user {
          width: 210px;
        }

        .create-time {
          width: 325px;
        }
      }

      .table-body {
        tr {
          width: 706px;
          height: 56px !important;

          &:nth-child(2n-1) {
            background: #F5F7FB;
          }

          td {
            text-align: center;
            font-size: 14px;
            padding: 0;
            display: table-cell;
            vertical-align: middle;
            height: 56px !important;
            color: #20395B;
          }
        }
      }
    }
  }
}
</style>
